import { FORBIDDEN_SPECIALTIES } from '../const/globals.const';

export function isForbiddenSpecialty(specialtyName: string) {
  return FORBIDDEN_SPECIALTIES.includes(specialtyName);
}

export function getCommonDayNumber(dayNumber: number) {
  return ((dayNumber + 1) % 7) + 1;
}
